import { Flex } from "grid-styled";
import { Flex as UIFlex, Icon, IconButton, ActionsGroup } from "@evergis/ui";
import styled, { css } from "styled-components";

export const AddAttribute = styled(Flex)`
  align-items: center;
  margin-right: 0.5rem;
`;

export const AddAttributeIconButton = styled(IconButton)`
  span {
    font-family: Roboto !important;
  }
`;

export const AttributeTypeSelect = styled.div``;

export const GeometryTypes = styled(UIFlex)`
  background-color: ${({ theme: { palette } }) => palette.element};
  padding: 0.5rem;
  align-items: center;
  margin-bottom: 2rem;
  border-radius: 0.75rem;
  box-sizing: border-box;
  width: 100%;
  gap: 0 0.5rem;
  flex-wrap: nowrap;
  display: flex;
  flex-direction: row;
`;

export const GeometryTypeContainer = styled(UIFlex)<{ selected: boolean }>`
  height: 4.625rem;
  flex: 1;
  flex-direction: column;
  background-color: transparent;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: ${({ theme: { palette } }) => palette.textSecondary};
  border: 1px solid transparent;
  border-radius: 0.5rem;

  &:hover {
    background-color: ${({ theme: { palette } }) => palette.element};
  }
  ${({ selected }) =>
    selected
      ? css`
          color: ${({ theme: { palette } }) => palette.primary};
          border-color: ${({ theme: { palette } }) => palette.primary};
          background-color: rgba(0, 170, 255, 0.06);

          ${Icon}:after {
            color: ${({ theme: { palette } }) => palette.primary};
          }
        `
      : ""}
`;

export const GeometryTypeIcon = styled(Icon)`
  width: 1.5rem;
  height: 1.5rem;

  &:after {
    font-size: 1.5rem;
  }
`;

export const GeometryTypeTitle = styled.label`
  font-size: 14px;
  margin-top: 0.75rem;
  cursor: pointer;
  text-align: center;
`;

export const Label = styled.label`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.palette.textSecondary};
  margin-bottom: 0.75rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-left: 3rem;
  padding-right: 3rem;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 2.5rem;
  padding-top: 3rem;
  padding-left: 3rem;
  margin-bottom: 2rem;
  box-sizing: border-box;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleText = styled.div`
  font-size: 1.5rem;
`;

export const TitleWizard = styled.div`
  margin-left: 1.5rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const StyledActionsGroup = styled(ActionsGroup)`
  margin-left: auto;
  flex-shrink: 0;
`;
